export default __webpack_public_path__ + "static/media/DSC_0501.05288c16.webp";